import { Navigate, useParams } from 'react-router-dom';

import { routerKeys } from '~shared/router';

import { SectionEdit } from './SectionEdit/SectionEdit';

export function EditPage() {
	const { id: sectionId } = useParams<{ id: string }>();

	if (!sectionId) return <Navigate to={routerKeys.page404()} />;

	return (
		<>
			<h3>{sectionId === 'add' ? 'Добавить' : 'Редактировать'} участок</h3>
			<SectionEdit sectionId={sectionId} />
		</>
	);
}
